<div class="section">
  <pdq-heading element="h5">Appearance</pdq-heading>
  <div class="controls-wrapper">
    <span class="subtitle">Multiple Goals Display</span>
    <div class="toggle-group">
      <button
        type="button"
        (click)="goalsConfig.get('displayMode')?.setValue(GoalsDisplayMode.SEQUENTIAL)"
        [class.active]="goalsConfig.get('displayMode')?.value === GoalsDisplayMode.SEQUENTIAL">
        Sequential
      </button>
      <button
        type="button"
        (click)="goalsConfig.get('displayMode')?.setValue(GoalsDisplayMode.INLINE)"
        [class.active]="goalsConfig.get('displayMode')?.value === GoalsDisplayMode.INLINE">
        Inline
      </button>
      <button
        type="button"
        (click)="goalsConfig.get('displayMode')?.setValue(GoalsDisplayMode.SINGLE_BAR)"
        [class.active]="goalsConfig.get('displayMode')?.value === GoalsDisplayMode.SINGLE_BAR">
        Single Bar
      </button>
    </div>
    <pdq-checkbox
      [checked]="goalsConfig.get('showPreviousGoals')?.value"
      (onChange)="goalsConfig.get('showPreviousGoals')?.setValue($event)"
      label="Show Previous Goals As Pills"
      labelSize="small">
    </pdq-checkbox>

    <div class="advanced-styling-container">
      <span class="subtitle-small">Advanced styling</span>
      <span class="subtitle-small">Main background</span>

      <div class="dropdowns-row">
        <div class="dropdown-field">
          <pdq-dropdown
            title="Border"
            [ngModel]="goalsConfig.get('border')?.value"
            (ngModelChange)="goalsConfig.get('border')?.setValue($event)"
            [options]="borderOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Border">
          </pdq-dropdown>
        </div>
        <div class="dropdown-field">
          <pdq-dropdown
            title="Border Width"
            [ngModel]="goalsConfig.get('borderWidth')?.value"
            (ngModelChange)="goalsConfig.get('borderWidth')?.setValue($event)"
            [options]="borderWidthOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Border Width">
          </pdq-dropdown>
        </div>
      </div>

      <div class="dropdowns-row">
        <div class="dropdown-field">
          <pdq-dropdown
            title="Corner Radius"
            [ngModel]="goalsConfig.get('cornerRadius')?.value"
            (ngModelChange)="goalsConfig.get('cornerRadius')?.setValue($event)"
            [options]="cornerRadiusOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Corner Radius">
          </pdq-dropdown>
        </div>
        <div class="dropdown-field">
          <pdq-dropdown
            title="Padding"
            [ngModel]="goalsConfig.get('padding')?.value"
            (ngModelChange)="goalsConfig.get('padding')?.setValue($event)"
            [options]="paddingOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Padding">
          </pdq-dropdown>
        </div>
      </div>

      <span class="subtitle-small">Progress Bar</span>

      <div class="dropdowns-row">
        <div class="dropdown-field">
          <pdq-input-color
            label="Color"
            [ngModel]="goalsConfig.get('progressBarColor')?.value"
            (ngModelChange)="goalsConfig.get('progressBarColor')?.setValue($event)">
          </pdq-input-color>
        </div>
        <div class="dropdown-field">
          <pdq-dropdown
            title="Label Size"
            [ngModel]="goalsConfig.get('progressBarLabelSize')?.value"
            (ngModelChange)="goalsConfig.get('progressBarLabelSize')?.setValue($event)"
            [options]="labelSizeOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Label Size">
          </pdq-dropdown>
        </div>
      </div>
    </div>
  </div>
</div>

@for (goal of goals; track goal.id; let goalIndex = $index) {
  <div class="section">
    <div class="section-header">
      <pdq-heading element="h5">Goal {{ goalIndex + 1 }}</pdq-heading>
      <div class="section-header-actions">
        @if (goalIndex > 0) {
          <pdq-button
            iconColor="var(--on-surface-light)"
            icon="delete"
            variant="ghost"
            (onClick)="removeGoal(goalIndex)">
          </pdq-button>
        }
        <pdq-slide-toggle
          [ngModel]="goals.length === 1 ? true : goal.enabled"
          [locked]="goals.length === 1"
          (ngModelChange)="onGoalEnabledChange(goalIndex, $event)">
        </pdq-slide-toggle>
      </div>
    </div>
    <div class="controls-wrapper">
      <p class="description-text">Offer discount to carts that have these values:</p>

      <div class="configuration-container">
        @if (getThresholdsFormArray(goalIndex)?.controls?.length) {
          <div class="configuration-row configuration-row__label">
            <pdq-label class="configuration-row__country-dropdown">Select country</pdq-label>
            <pdq-label class="configuration-row__threshold-input">{{
              thresholdType === IUpsellThresholdTypes.ItemCount ? 'Item count' : 'Threshold'
            }}</pdq-label>
            @if (thresholdType !== IUpsellThresholdTypes.ItemCount) {
              <pdq-label>Currency</pdq-label>
            }
          </div>
        }

        @for (thresholdConfig of getThresholdsFormArray(goalIndex)?.controls; track thresholdConfig; let i = $index) {
          <div class="configuration-row">
            @if (thresholdConfig) {
              <country-and-states-dropdown
                class="configuration-row__country-dropdown"
                [control]="thresholdConfig.get('countriesAndRegions')">
              </country-and-states-dropdown>
            }
            <pdq-input-arrows
              class="configuration-row__threshold-input"
              [formControl]="thresholdConfig.controls.threshold"
              [min]="getThresholdMinValue()"
              [precision]="thresholdType === IUpsellThresholdTypes.CartValue ? 2 : 0"
              [step]="thresholdType === IUpsellThresholdTypes.CartValue ? 0.01 : 1">
            </pdq-input-arrows>
            @if (thresholdType !== IUpsellThresholdTypes.ItemCount) {
              <pdq-dropdown
                class="configuration-row__currency-dropdown"
                [formControl]="thresholdConfig.get('currency')"
                [options]="currencyCodes | primitiveDropdownOptionsPipe">
              </pdq-dropdown>
            }
            <pdq-button
              iconColor="var(--on-surface-light)"
              icon="close"
              variant="ghost"
              (onClick)="removeThresholdForGoal(goalIndex, i)">
            </pdq-button>
          </div>
          @if (getThresholdError(goalIndex, i)) {
            <span class="threshold-error">{{ getThresholdError(goalIndex, i) }}</span>
          }
        }
      </div>
      <pdq-button (onClick)="addThresholdForGoal(goalIndex)" label="+Add threshold"></pdq-button>

      <div class="offer-type-field">
        <pdq-dropdown
          title="Offer type"
          [ngModel]="goal.offerType"
          (ngModelChange)="onGoalOfferTypeChange(goalIndex, $event)"
          [options]="offerTypeOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Choose type">
        </pdq-dropdown>
      </div>

      @if (goalsConfig.get('displayMode')?.value !== GoalsDisplayMode.SEQUENTIAL) {
        <pdq-checkbox
          class="show-info-checkbox"
          [checked]="goal.showInfoInProgressBar"
          (onChange)="onGoalShowInfoInProgressBarChange(goalIndex, $event)"
          label="Show info In Progress Bar"
          labelSize="medium">
        </pdq-checkbox>

        @if (goal.showInfoInProgressBar) {
          <pdq-input
            [ngModel]="goal.progressBarLabel"
            (ngModelChange)="onGoalProgressBarLabelChange(goalIndex, $event)"
            label="Label"
            placeholder="Enter label">
          </pdq-input>
        }
      }

      <!--
      @if (goal.offerType === 'coupon' && discountStackingMode === DiscountStackingMode.OVERRIDE) {
        <div class="offer-type-description">
          Configure this {{ goal.offerType }} in the Gift Unlock Extension, then return here to select it from the
          dropdown below
        </div>
        <div class="gift-unlock-field">
          <pdq-dropdown
            title="Gift Unlock Extension"
            tooltip="Under Override discount stacking, set this coupon's Gift Unlock to 'Keep In Cart' if it's activated by a cart value rule — so the customer keeps the coupon and dropping below the threshold won't remove it."
            tooltipPosition="above"
            [defaultOption]="getSelectedGiftUnlockOption(goalIndex)"
            (onChange)="onGoalGiftUnlockExtensionChange(goalIndex, $event?.value)"
            [options]="getGiftUnlockExtensionsForGoal(goalIndex)"
            optionLabel="label"
            optionValue="value"
            [invalid]="!!giftUnlockErrors[goalIndex]"
            [invalidMsg]="giftUnlockErrors[goalIndex]"
            placeholder="Select gift unlock extension">
          </pdq-dropdown>
        </div>

        @if (getSelectedGiftUnlockExtensionObject(goalIndex); as selectedExt) {
          @if (!selectedExt.enabled) {
            <pdq-banner
              [bannerTitle]="
                'This &quot;' + (selectedExt.template?.internalName || 'extension') + '&quot; extension is not active'
              "
              [content]="'Please activate it or select a different extension in order for this goal to be displayed'"
              variant="attention"
              [closable]="false">
            </pdq-banner>
          }
        }
      }
-->

      <div class="upsell-title">
        <div class="rich-textarea-container-wrapper">
          <div class="rich-textarea-container">
            <div class="rich-text-area-header-wrapper">
              <label class="rich-textarea-label">Display Text When Goal Is Not Met</label>
              @if (thresholdType !== IUpsellThresholdTypes.NoThreshold) {
                <pdq-button
                  class="eye-preview-button"
                  variant="empty"
                  [icon]="isTextVisible(goalIndex, UpsellTextType.Threshold) ? 'preview_eye' : 'preview_eye_crossed'"
                  [iconColor]="
                    isTextVisible(goalIndex, UpsellTextType.Threshold)
                      ? 'var(--primary-default)'
                      : 'var(--on-surface-light)'
                  "
                  (click)="togglePreviewText(goalIndex, UpsellTextType.Threshold)">
                </pdq-button>
              }
            </div>
            <rich-textarea
              [initialContent]="getTextWithThreshold(goalIndex)"
              placeholder="Enter your message here..."
              [enableLinkInsert]="true"
              [class.disabled]="thresholdType === IUpsellThresholdTypes.NoThreshold"
              [disabledFormats]="['underline']"
              (contentChange)="onTextWithThresholdChange(goalIndex, $event)">
            </rich-textarea>
            @if (textWithThresholdError) {
              <span class="error-message">{{ textWithThresholdError }}</span>
            }
          </div>
        </div>
      </div>
      @if (goal.textWithThreshold?.includes(UpsellFreeShippingThresholdReplaceValues.AmountLeft)) {
        <span class="description">
          Use the tag {{ UpsellFreeShippingThresholdReplaceValues.AmountLeft }} to dynamically display the $ amount left
          to reach the threshold
        </span>
      }
      @if (goal.textWithThreshold?.includes(UpsellFreeShippingThresholdReplaceValues.ItemsLeft)) {
        <span class="description">
          Use the tag {{ UpsellFreeShippingThresholdReplaceValues.ItemsLeft }} to dynamically display the # of items
          left to reach the threshold
        </span>
      }

      <div class="upsell-title">
        <div class="rich-textarea-container-wrapper">
          <div class="rich-textarea-container">
            <div class="rich-text-area-header-wrapper">
              <label class="rich-textarea-label">Display Text When Goal Is Met</label>
              @if (thresholdType !== IUpsellThresholdTypes.NoThreshold) {
                <pdq-button
                  class="eye-preview-button"
                  variant="empty"
                  [icon]="isTextVisible(goalIndex, UpsellTextType.NoThreshold) ? 'preview_eye' : 'preview_eye_crossed'"
                  [iconColor]="
                    isTextVisible(goalIndex, UpsellTextType.NoThreshold)
                      ? 'var(--primary-default)'
                      : 'var(--on-surface-light)'
                  "
                  (click)="togglePreviewText(goalIndex, UpsellTextType.NoThreshold)">
                </pdq-button>
              }
            </div>
            <rich-textarea
              [initialContent]="getTextWithoutThreshold(goalIndex)"
              placeholder="Enter your message here..."
              [enableLinkInsert]="true"
              [disabledFormats]="['underline']"
              (contentChange)="onTextWithoutThresholdChange(goalIndex, $event)">
            </rich-textarea>
            @if (textWithoutThresholdError) {
              <span class="error-message">{{ textWithoutThresholdError }}</span>
            }
          </div>
        </div>
      </div>

      <div class="show-message-if-free-shipping-wrapper">
        <pdq-checkbox
          class="show-message-if-free-shipping-checkbox"
          [checked]="getShowMessageIfFreeShippingAvailable(goalIndex)"
          (onChange)="onShowMessageChange(goalIndex, $event)"
          label="Show Message If Free Shipping Is Available"
          labelSize="medium">
        </pdq-checkbox>
        <div class="show-message-if-free-shipping-description">
          Show this message when any free shipping option is available - even if the threshold isn't met
        </div>
      </div>

      @if (
        goalsConfig.get('displayMode')?.value === GoalsDisplayMode.SEQUENTIAL &&
        goalsConfig.get('showPreviousGoals')?.value
      ) {
        <pdq-input
          [ngModel]="goal.progressBarLabel"
          (ngModelChange)="onGoalProgressBarLabelChange(goalIndex, $event)"
          label="Label"
          placeholder="Enter label">
        </pdq-input>
      }

      <pdq-input-file
        (onPreviewChange)="onIconPreviewChange(goalIndex, $event)"
        (onClearFile)="onClearIcon(goalIndex)"
        fileType="img"
        label="Icon"
        tooltip=".png, maximum size 100KB&#10;Recommended size up to 20x20"
        variant="optionlist"
        [initialImage]="getDefaultIconForGoal(goalIndex)"
        [file]="goal.iconUrl">
      </pdq-input-file>
    </div>
  </div>

  @if (goalIndex === goals.length - 1) {
    <pdq-button class="add-goal-button" variant="primary" (onClick)="addGoal()" label="+Add Goal"></pdq-button>
  }
}
